import Doughnut from 'doughnut';

export default Doughnut;
